// extracted by mini-css-extract-plugin
module.exports = {"root":"StreamEditorUserActions-module__root__1_xhZ"};